import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, DetalhesDiarioOficialReducer, DetalhesDiarioOficialState } from './detalhes-diario-oficial-reducer';
import { IOfficialDiaryDetailResponse } from '../../../../model/official-daily/response/official-diary-detail-response';

const DetalhesDiarioOficialContext = createContext<DetalhesDiarioOficialState | undefined>(undefined);
const DetalhesDiarioOficialContextDispatchContext = createContext({} as any);

const DetalhesDiarioOficialProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(DetalhesDiarioOficialReducer, { officialDiaryDetailResponse: {  } as IOfficialDiaryDetailResponse } as DetalhesDiarioOficialState);

    return (
        <DetalhesDiarioOficialContext.Provider value={state}>
            <DetalhesDiarioOficialContextDispatchContext.Provider value={dispatch}>
                {children}
            </DetalhesDiarioOficialContextDispatchContext.Provider>
        </DetalhesDiarioOficialContext.Provider>
    );
}

const useDetalhesDiarioOficialState = () => {
    const context = useContext(DetalhesDiarioOficialContext);
    if (context === undefined) {
        throw new Error('useHomeState must be used within a HomeProvider');
    }
    return context;
}

const useDetalhesDiarioOficialDispatch = () => {
    const context = useContext(DetalhesDiarioOficialContextDispatchContext);
    if (context === undefined) {
        throw new Error('useHomeDispatch must be used within a HomeProvider');
    }
    return context;
}

export { DetalhesDiarioOficialProvider, useDetalhesDiarioOficialDispatch, useDetalhesDiarioOficialState, ACTION_TYPES };
